import Proptypes from 'prop-types';
import React, { useCallback } from 'react';

import { ArrowLeftRight } from 'lucide-react';

import NewDropDown from './NewDropDown';

export default function LetterSpacingFormatter({ editor, tooltipText, ...props }) {
  const handleClickOption = useCallback(value => editor.chain().focus().setLetterSpacing(value === 'Normal' ? 0 : value).run(), [editor])

  return <NewDropDown
    options={SIZES}
    onClickOption={handleClickOption}
    tooltipText={tooltipText}
    icon={ArrowLeftRight} {...props}
    name='letterSpacing'
    editor={editor}
    creatable
  />
}

const SIZES = ['Normal', '1px', '2px', '3px', '4px', '5px', '6px', '7px', '8px', '9px', '10px']

LetterSpacingFormatter.propTypes = {
  editor: Proptypes.object,
  tooltipText: Proptypes.string,
}
